/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Referral_Step1_SubInputs */

const tr_landing_referral_step1_sub = /** @type {(inputs: Landing_Referral_Step1_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panelinizdeki davet linkini WhatsApp'tan gönderin.`)
};

const en_landing_referral_step1_sub = /** @type {(inputs: Landing_Referral_Step1_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send the invite link from your panel via WhatsApp.`)
};

const de_landing_referral_step1_sub = /** @type {(inputs: Landing_Referral_Step1_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden Sie den Einladungslink aus Ihrem Panel per WhatsApp.`)
};

const ru_landing_referral_step1_sub = /** @type {(inputs: Landing_Referral_Step1_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправьте пригласительную ссылку из панели через WhatsApp.`)
};

/**
* | output |
* | --- |
* | "Send the invite link from your panel via WhatsApp." |
*
* @param {Landing_Referral_Step1_SubInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_referral_step1_sub = /** @type {((inputs?: Landing_Referral_Step1_SubInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Referral_Step1_SubInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_referral_step1_sub(inputs)
	if (locale === "de") return de_landing_referral_step1_sub(inputs)
	if (locale === "ru") return ru_landing_referral_step1_sub(inputs)
	return tr_landing_referral_step1_sub(inputs)
});